import React, { useState } from "react";
import CoursesTab from "../../Components/tabs/Courses";
import CourseEnrollment from "../../Components/tabs/CourseEnrollment";

function CoursesManagement() {
  const tabs = [
    "Courses",
    "Course Enrollment",
  ];
  const [activeTab, setActiveTab] = useState("Courses"); // Default tab

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="container mx-auto p-4 border border-[#241763]">
      {/* Tabs */}
      <div className="flex space-x-4 border-2 border-gray-100 shadow-xl mb-4 pb-3 pt-2 rounded-b-xl">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabClick(tab)}
            className={`px-4 py-2 ${
              activeTab === tab ? "text-white bg-[#241763]" : "bg-gray-200 text-gray-700"
            } rounded-t-md`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "Courses" && (
          <CoursesTab />
        )}

        {activeTab === "Course Enrollment" && (
          <CourseEnrollment />
        )}
      </div>
    </div>
  );
}

export default CoursesManagement;